import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="container pt-5 pb-4 ">
      <div className="row align-items-center">
        <div className="col-md-9 col-lg-6 col-xl-6 mx-auto  text-wrap text-sm-center">
          <p>
            This project was developed by{" "}
            <a
              href="https://github.com/punSavitri"
              target="_blank"
              rel="noreferrer"
            >
              Savitri Pun
            </a>
            {""} available on {""}
            <a
              href="https://github.com/punSavitri/weatherforecast-reactapp.git"
              target="_blank"
              rel="noreferrer"
            >
              as open-source on GitHub repository
            </a>{" "}
            and deployed using{" "}
            <a
              href="https://weatherforecastreactapp.savitripun.co.uk/"
              target="_blank"
              rel="noreferrer"
            >
              Hostinger platform
            </a>{" "}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
